module.exports = __webpack_public_path__ + "static/media/Perfil.38297733.jpg";